import CommonError from '../Common/CommonError'

const Error503Container = () => {
  return (
    <CommonError error="503" color="secondary" src="sad5" />
  )
}

export default Error503Container